module.exports = __webpack_public_path__ + "static/media/NO-MAD_Portfolio.5875fd08.pdf";